export default "__VITE_ASSET__0a6d0de9__"